import React, { useState, useEffect } from "react";
import { Modal, Button, List, Typography, Alert } from "antd";

const { Text } = Typography;

export default function CategorySelectorModal({ open, onClose, onAccept, categoriesData }) {
  const [selectionPath, setSelectionPath] = useState([]);
  const [processedCategories, setProcessedCategories] = useState([]);

  useEffect(() => {
    if (categoriesData && categoriesData.length > 0) {
      const buildHierarchy = (categories) => {
        const categoryMap = new Map();
        const rootCategories = [];

        categories.forEach(category => {
          categoryMap.set(category.slug, {
            ...category,
            subCategories: [],
            name: category.name,
            category: category.name
          });
        });
        categories.forEach(category => {
          const categoryNode = categoryMap.get(category.slug);

          if (category.parent_slug) {
            const parent = categoryMap.get(category.parent_slug);
            if (parent) {
              parent.subCategories.push(categoryNode);
            } else {
              rootCategories.push(categoryNode);
            }
          } else {
            rootCategories.push(categoryNode);
          }
        });

        return rootCategories;
      };

      const hierarchy = buildHierarchy(categoriesData);
      setProcessedCategories(hierarchy);
    } else {
      setProcessedCategories([]);
    }
  }, [categoriesData]);

  const columns = [];
  let currentLevel = processedCategories;

  for (let i = 0; i <= selectionPath.length; i++) {
    columns.push(currentLevel);
    const selectedNode = selectionPath[i];
    if (!selectedNode) break;
    currentLevel = selectedNode.subCategories || [];
  }

  const handleSelect = (node, level) => {
    const newPath = [...selectionPath.slice(0, level), node];
    setSelectionPath(newPath);
  };

  const selectedNode =
    selectionPath.length > 0
      ? selectionPath[selectionPath.length - 1]
      : null;

  const isLeaf =
    selectedNode && (!selectedNode.subCategories || selectedNode.subCategories.length === 0);

  const handleAccept = () => {
    if (isLeaf) {
      onAccept({
        categoryChain: selectionPath.map((n) => n.slug),
        selected: selectedNode,
      });
      setSelectionPath([]);
      onClose();
    }
  };

  const handleClose = () => {
    setSelectionPath([]);
    onClose();
  };

  return (
    <Modal
      title="Selecciona una categoría"
      open={open}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Cancelar
        </Button>,
        <Button
          key="accept"
          type="primary"
          onClick={handleAccept}
          disabled={!isLeaf}
        >
          Aceptar
        </Button>,
      ]}
      width="80%"
    >
      {processedCategories.length === 0 ? (
        <Alert
          message="No hay categorías disponibles"
          description="Las categorías no se han cargado o no hay categorías creadas."
          type="warning"
          showIcon
        />
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: `repeat(${columns.length}, 1fr)`, gap: 16, maxHeight: '400px', overflow: 'auto' }}>
          {columns.map((items, level) => (
            <List
              key={level}
              bordered
              dataSource={items}
              renderItem={(item) => {
                const isSelected = selectionPath[level]?.slug === item.slug;
                return (
                  <List.Item
                    onClick={() => handleSelect(item, level)}
                    style={{
                      cursor: "pointer",
                      background: isSelected ? "#e6f4ff" : undefined,
                      padding: '8px 12px',
                    }}
                  >
                    <Text strong={isSelected}>{item.name || item.category}</Text>
                  </List.Item>
                );
              }}
            />
          ))}
        </div>
      )}

      {selectedNode && (
        <div style={{ marginTop: 16, padding: 12, background: '#f0f8ff', borderRadius: 6 }}>
          <Text strong>Selección actual: </Text>
          <Text>{selectionPath.map(n => n.name || n.category).join(' → ')}</Text>
          {!isLeaf && (
            <div style={{ marginTop: 8 }}>
              <Text type="warning">Selecciona una subcategoría final para continuar</Text>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
}